@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-form-array {
    display: flex;
    flex-direction: column;

    // == Section Detail (Optional)

    .form-array-section-detail {
      margin-bottom: 1em;
    }

    // == Entry Container (Fieldset)

    .form-array-fieldset {
      min-width: 0;
      margin: 0;
      padding-inline: 0;
      padding-block-start: 0.5em;
      padding-block-end: 2em;
      border-width: 1px 0 0 0;
      border-color: var(--fieldset-border-color);
      border-style: solid;

    &.highlighted {
      border: 2px solid #{$liberty-gray-10};
      // border: 2px solid #e92243;
      transition: background-color 10ms 30ms ease;
      background-color:  #{$liberty-gray-4};
    }

      legend {
        font-family: inherit;
        font-size: var(--fieldset-font-size);
        line-height: inherit;
        color: var(--fieldset-color);
        font-weight: $font-weight-bold;
        padding-inline-start: 0;
        padding-inline-end: 0.5em;
      }

      .fieldset-controls {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    // == Control Buttons Container

    .form-array-controls {
      display: flex;
      justify-content: center;
      column-gap: 3em;
    }

    .cancel-container {
      margin-top: var(--controls-cancel-margin-top);
      &.top-align {
        margin-top: var(--controls-cancel-top-align-margin-top);
      }
    }
  }
}
